var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { applyMargins } from '../../utils/tailwind';
import { logo } from './styles';
import { Swile } from './swile';
export const Logo = (_a) => {
    var { inverted, height = 48, className } = _a, props = __rest(_a, ["inverted", "height", "className"]);
    const { m, ml, mr, mb, mt, mx, my, display } = props, otherProps = __rest(props, ["m", "ml", "mr", "mb", "mt", "mx", "my", "display"]);
    return (_jsx("div", Object.assign({}, otherProps, { style: Object.assign({}, (height && {
            '--logo-height': `${height}px`,
            '--logo-width': `${height * 3}px`,
        })), className: logo({
            inverted,
            customHeight: !!height,
            display,
            className: [applyMargins({ m, ml, mr, mb, mt, mx, my }), className],
        }), children: _jsx(Swile, {}) })));
};
